export default __webpack_public_path__ + "static/media/projects4.d83a444d.jpg";